var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCss = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  height: 2500,
  width: 2183,
  viewBox: "0 0 124 141.53"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.383 126.892 0 0l124 .255-10.979 126.637-50.553 14.638z",
  fill: "#1b73ba"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.468 129.275V12.085l51.064.17-9.106 104.85z",
  fill: "#1c88c7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M100.851 27.064H22.298l2.128 15.318h37.276l-36.68 15.745 2.127 14.808h54.043l-1.958 20.68-18.298 3.575-16.595-4.255-1.277-11.745H27.83l2.042 24.426 32.681 9.106 31.32-9.957 4-47.745H64.765l36.085-14.978z",
  fill: "#fff"
})));
export { SvgCss as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/css.svg";